import React, { useState, useEffect } from "react";
import "./signup.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const SignUp = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    Email: "",
    CountryCode: "",
    Mobile: "",
    Password: "",
    ConfirmPass: "",
    fName: "",
    lName: "",
  });
  const [error, setError] = useState("");

  //check user login or not
  useEffect(() => {
    if (localStorage.getItem("auth")) {
      navigate("/");
    }
  }, []);

  const handleChange = (e) => {
    setError("");
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };
  const submit = async () => {
    //validations
    if (
      !user.Email ||
      !user.CountryCode ||
      !user.Mobile ||
      !user.Password ||
      !user.ConfirmPass ||
      !user.fName
    ) {
      setError("All fields are required");
      return false;
    } else {
      if (user.Password !== user.ConfirmPass) {
        setError("Password And Confirm Password Must Be Same");
      } else {
        let apidata = await fetch(`${process.env.REACT_APP_SERVER}/api/register`, {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Email: user.Email,
            CountryCode: user.CountryCode,
            Mobile: user.Mobile,
            Password: user.Password,
            Name: user.fName + " " + user.lName,
          }),
        });

        apidata = await apidata.json();

        //error show in component
        if (!apidata.success) {
          setError(apidata.message);
        } else {
          navigate("/signin");
        }
      }
    }
  };

  return (
    <div className="register">
      <h1>Register</h1>
      <input
        type="text"
        name="fName"
        value={user.fName}
        placeholder="First Name"
        onChange={handleChange}
      ></input>
      <input
        type="text"
        name="lName"
        value={user.lName}
        placeholder="Last Name"
        onChange={handleChange}
      ></input>
      <input
        type="text"
        name="Email"
        value={user.Email}
        placeholder="Your Email"
        onChange={handleChange}
      ></input>
      <input
        type="text"
        name="CountryCode"
        value={user.CountryCode}
        placeholder="Country Code"
        onChange={handleChange}
      ></input>
      <input
        type="number"
        name="Mobile"
        value={user.Mobile}
        placeholder="Mobile"
        onChange={handleChange}
      ></input>
      <input
        type="Password"
        name="Password"
        value={user.Password}
        placeholder="Your Password"
        onChange={handleChange}
      ></input>
      <input
        type="Password"
        name="ConfirmPass"
        value={user.ConfirmPass}
        placeholder="Re-enter Password"
        onChange={handleChange}
      ></input>
      <p style={{ color: "red" }}>{error}</p>
      <div className="button" onClick={submit}>
        Register
      </div>
      <div>or</div>
      <div
        className="button"
        onClick={() => {
          navigate(navigate("/signin"));
        }}
      >
        Login
      </div>
    </div>
  );
};
export default SignUp;
